module.exports = __webpack_public_path__ + "static/kevin-circle-low.acdb1671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kevin-circle-low.jpg
// module id = 884
// module chunks = 169928946856436